import React, { useEffect, useState } from "react";
import qs from "qs";
import { useParams } from "react-router-dom";
import { socketFunc } from "../../../../utils/socketUtil";
import { Toaster } from "../../../../utils/toaster";
import AppIframe from "../../../components/AppIframe";
import HeaderAfterLogin from "../../../../containers/HeaderAfterLogin";

const DynamicGames = () => {
  const { provider } = useParams();
  const token = localStorage.getItem("token");
  const socket = socketFunc(token);
  const [iframeUrl, setIframeUrl] = useState("");

  useEffect(() => {
    const decodedParams = decodeURIComponent(window.location.href);
    const parsedValues = qs.parse(decodedParams.split("?")?.[1] || "");
    getLobby(parsedValues);
  }, [provider]);

  const getLobby = (params) => {
    socket.emit(
      "get:sports_lobby",
      {
        providerCode: provider?.toUpperCase(),
        ...params,
      },
      (res) => {
        if (res?.status === "failed") {
          Toaster.Error(res?.message || "Failed to get");
        }
        if (res?.status === "success") {
          handleResponse(res);
        }
      }
    );
  };

  const handleResponse = (value) => {
    if (value?.data && typeof value?.data === "string") {
      setIframeUrl(value?.data);
    } else if (value?.data && "lobbyUrl" in value?.data?.data) {
      setIframeUrl(value?.data?.data?.lobbyUrl);
    } else {
      setIframeUrl("");
    }
  };

  return (
    <div className="live_casino_page live">
      <HeaderAfterLogin />

      {/* <div className="d-xl-none">
          <LeftBarSports />
        </div> */}

      <AppIframe
        iframeUrl={iframeUrl}
        isRedirectionRequired={false}
        style={{
          width: "100%",
          height: "calc(100vh - 50px)",
        }}
      />

      <div>{/* <BottomNav /> */}</div>
    </div>
  );
};
export default DynamicGames;
